import React, {useState} from "react";
import {motion} from "framer-motion";
import styles from "../Parigi.module.css";

const BIRTH_DATE = "2000-08-20"; // 20 Agosto 2000
const BIRTH_TIME = "11:22";      // 11:22

const AccessGate = ({onUnlock}) => {
    const [date, setDate] = useState("");
    const [time, setTime] = useState("");
    const [error, setError] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (date === BIRTH_DATE && time === BIRTH_TIME) {
            setError(false);
            onUnlock();
        } else {
            setError(true);
        }
    };

    return (
        <motion.div
            key="gate"
            initial={{opacity: 0}}
            animate={{opacity: 1}}
            exit={{opacity: 0, scale: 0.96}}
            transition={{duration: 0.5}}
            className={styles.gateWrapper}
        >
            <div className={`card shadow-sm ${styles.gateCard}`}>
                <div className="card-body text-center">
                    <h2 className={styles.gateTitle}>Un regalo per te 💚</h2>
                    <p className="text-muted mb-4">Per continuare, dimmi quando sei nata.</p>
                    <form onSubmit={handleSubmit}>
                        <div className="mb-3 text-start">
                            <label className="form-label">Data di nascita</label>
                            <input
                                type="date"
                                className="form-control"
                                value={date}
                                onChange={(e) => setDate(e.target.value)}
                                required
                            />
                        </div>
                        <div className="mb-3 text-start">
                            <label className="form-label">Ora di nascita</label>
                            <input
                                type="time"
                                className="form-control"
                                value={time}
                                onChange={(e) => setTime(e.target.value)}
                                required
                            />
                        </div>
                        <button type="submit" className={`btn btn-primary w-100 ${styles.gateButton}`}>
                            Entra
                        </button>
                        {error && (
                            <div className="alert alert-warning mt-3 mb-0">
                                Non è la data giusta... riprova 💚
                            </div>
                        )}
                    </form>
                </div>
            </div>
        </motion.div>
    );
};

export default AccessGate;
